import { Component } from '@angular/core';

@Component({
    selector: 'app-terms-n-conditions',
    imports: [],
    templateUrl: './terms-n-conditions.component.html',
    styleUrl: './terms-n-conditions.component.css'
})
export class TermsNConditionsComponent {

}
